import _isEmpty from "lodash/isEmpty";
import moment from "moment";
import papaparse from "papaparse";
import _ from "lodash";

let siteDetails;

function getCountries(data) {
  if (_isEmpty(data)) {
    return [];
  } else {
    return Object.keys(data);
  }
}

function primaryColorFnc() {
  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#00C3B3";
  return primaryColor;
}

function getContrast(hexcolorOld) {
  let hexcolor = hexcolorOld;
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map(function(hex) {
        return hex + hex;
      })
      .join("");
  }

  const r = parseInt(hexcolor.substr(0, 2), 16) * 299;
  const g = parseInt(hexcolor.substr(2, 2), 16) * 587;
  const b = parseInt(hexcolor.substr(4, 2), 16) * 114;

  const yiq = (r + g + b) / 1000;
  return yiq >= 128 ? "#000000" : "#ffffff";
}

function getSites(data, choosedCountries = []) {
  const isEmptyData = _.isEmpty(data) || choosedCountries.length < 1;

  let siteList = new Set();
  if (!isEmptyData) {
    choosedCountries.forEach(countryName => {
      const countries = data[countryName];
      for (const siteName in countries) {
        siteList.add(siteName);
      }
    });

    return (siteList = [...siteList].sort((a, b) => b - a));
  }

  return [];
}

function checkProperties(obj) {
  for (const key in obj) {
    if (obj[key].value !== 0 && obj[key].value != "NaN") {
      return false;
    }
  }
  return true;
}

function getDataOverallMissingData(rawData, chosenCountries = [], chosenSites = [], tabIndex, dataType = "chart") {
  if (_isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return [];
  }

  const data = [];
  let response = [];
  const PREFIX_TOTAL_MISSING = "totalMissing";
  for (const countryName in rawData) {
    if (chosenCountries !== "all" && chosenCountries[0] !== "all" && !chosenCountries.includes(countryName)) {
      continue;
    }
    const countryData = rawData[countryName];
    for (const siteName in countryData) {
      if (chosenSites[0] !== "all" && !chosenSites.includes(siteName)) {
        continue;
      }
      const site = countryData[siteName];
      if (!site) {
        return;
      }
      for (const day in site) {
        const total = site[day][PREFIX_TOTAL_MISSING];

        const index = _.findIndex(data, ["label", day]);
        if (index < 0) {
          data.push({
            label: day,
            value: Number(total)
          });
        } else {
          data[index].value += Number(total);
        }
      }
    }
  }

  switch (tabIndex) {
    case 0:
      response = data;
      break;

    default:
      const total = _.sumBy(data, "value");
      data.forEach(row => {
        response.push({
          label: row.label,
          value: dataType === "chart" ? ((row.value / total) * 100).toFixed(0) : ((row.value / total) * 100).toFixed(2)
        });
      });
      break;
  }

  if (checkProperties(response)) {
    return [];
  } else {
    return response;
  }
}

function getQueriesData(rawData, chosenCountries = [], chosenSites = [], tabIndex) {
  if (_isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return [];
  }

  const data = [];
  let response = [];
  const PREFIX_QUERY_OPEN = "queryOpen";
  const PREFIX_QUERY_RESPONSE = "queryResponded";
  const PREFIX_QUERY_CLOSE = "queryClosed";
  for (const activityName in rawData) {
    chosenCountries.map(rowCountry => {
      chosenSites.map(rowSite => {
        const site = rawData[activityName][rowCountry] && rawData[activityName][rowCountry][rowSite];
        if (!site) {
          return;
        }
        for (const day in site) {
          const open = parseInt(site[day][PREFIX_QUERY_OPEN]);
          const respoded = parseInt(site[day][PREFIX_QUERY_RESPONSE]);
          const close = parseInt(site[day][PREFIX_QUERY_CLOSE]);
          const total = open + respoded + close;

          const index = _.findIndex(data, ["label", day]);
          if (index < 0) {
            data.push({
              label: day,
              value: Number(total),
              site: rowSite
            });
          } else {
            data[index].value += Number(total);
          }
        }
      });
    });
  }

  switch (tabIndex) {
    case 0:
      response = data;
      break;

    default:
      const total = _.sumBy(data, "value");
      data.forEach(row => {
        response.push({
          label: row.label,
          value: ((row.value / total) * 100).toFixed(1),
          site: row.site
        });
      });
      break;
  }

  if (response.length > 0) {
    const tmp4 = response[4];
    response[4] = response[3];
    response[3] = response[2];
    response[2] = tmp4;
  }
  return response;
}

function getQueriesStatusData(rawData, chosenCountries = [], chosenSites = [], tabIndex) {
  if (_isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return [];
  }

  const dataOpen = [];
  const dataResponded = [];
  const dataClosed = [];
  let category = [];
  const PREFIX_QUERY_OPEN = "queryOpen";
  const PREFIX_QUERY_RESPONSE = "queryResponded";
  const PREFIX_QUERY_CLOSE = "queryClosed";
  for (const activityName in rawData) {
    if (tabIndex === 1) {
      category.push({
        label: activityName
      });
    }
    chosenCountries.forEach(rowCountry => {
      chosenSites.forEach(rowSite => {
        const site = rawData[activityName][rowCountry] ? rawData[activityName][rowCountry][rowSite] : null;
        if (tabIndex === 2) {
          category.push({
            label: rowSite
          });
        }
        if (!site) {
          return;
        }
        for (const day in site) {
          const open = parseInt(site[day][PREFIX_QUERY_OPEN]);
          const respoded = parseInt(site[day][PREFIX_QUERY_RESPONSE]);
          const close = parseInt(site[day][PREFIX_QUERY_CLOSE]);

          if (tabIndex === 0) {
            category.push({
              label: day
            });
          }

          switch (tabIndex) {
            case 0:
              const index0 = _.findIndex(dataOpen, ["label", day]);
              if (index0 < 0) {
                dataOpen.push({
                  label: day,
                  value: open
                });
                dataResponded.push({
                  label: day,
                  value: respoded
                });
                dataClosed.push({
                  label: day,
                  value: close
                });
              } else {
                dataOpen[index0].value += open;
                dataResponded[index0].value += respoded;
                dataClosed[index0].value += close;
              }
              break;

            case 1:
              const index1 = _.findIndex(dataOpen, ["label", activityName]);
              if (index1 < 0) {
                dataOpen.push({
                  label: activityName,
                  value: open
                });
                dataResponded.push({
                  label: activityName,
                  value: respoded
                });
                dataClosed.push({
                  label: activityName,
                  value: close
                });
              } else {
                dataOpen[index1].value += open;
                dataResponded[index1].value += respoded;
                dataClosed[index1].value += close;
              }
              break;
            default:
              const index2 = _.findIndex(dataOpen, ["label", rowSite]);
              if (index2 < 0) {
                dataOpen.push({
                  label: rowSite,
                  value: open
                });
                dataResponded.push({
                  label: rowSite,
                  value: respoded
                });
                dataClosed.push({
                  label: rowSite,
                  value: close
                });
              } else {
                dataOpen[index2].value += open;
                dataResponded[index2].value += respoded;
                dataClosed[index2].value += close;
              }
              break;
          }
        }
      });
    });
  }

  category = _.uniqBy(category, "label");

  if (tabIndex === 0) {
    const tmpCategory = category[4];
    const tmpDataOpen = dataOpen[4];
    const tmpDataResponded = dataResponded[4];
    const tmpDataClosed = dataClosed[4];

    category[4] = category[3];
    category[3] = category[2];
    category[2] = tmpCategory;

    dataOpen[4] = dataOpen[3];
    dataOpen[3] = dataOpen[2];
    dataOpen[2] = tmpDataOpen;

    dataResponded[4] = dataResponded[3];
    dataResponded[3] = dataResponded[2];
    dataResponded[2] = tmpDataResponded;

    dataClosed[4] = dataClosed[3];
    dataClosed[3] = dataClosed[2];
    dataClosed[2] = tmpDataClosed;
  }

  return {
    category: _.uniqBy(category, "label"),
    dataOpen,
    dataResponded,
    dataClosed
  };
}

function getQueriesTop5(rawData, chosenCountries = [], chosenSites = [], tabIndex) {
  if (_isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return [];
  }

  const response = [];
  const PREFIX_QUERY_OPEN = "queryOpen";
  const PREFIX_QUERY_RESPONSE = "queryResponded";
  const PREFIX_QUERY_CLOSE = "queryClosed";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];

    chosenCountries.forEach(countryName => {
      if (countryName in activityData) {
        const countryData = activityData[countryName];

        chosenSites.forEach(siteName => {
          if (siteName in countryData) {
            const site = countryData[siteName];

            for (const day in site) {
              const open = parseInt(site[day][PREFIX_QUERY_OPEN]);
              const respoded = parseInt(site[day][PREFIX_QUERY_RESPONSE]);
              const close = parseInt(site[day][PREFIX_QUERY_CLOSE]);
              const total = open + respoded + close;

              const index = _.findIndex(response, ["label", activityName]);
              if (index < 0) {
                response.push({
                  label: activityName,
                  value: tabIndex < 1 ? total : open
                });
              } else {
                response[index].value += tabIndex < 1 ? total : open;
              }
            }
          }
        });
      }
    });
  }
  return _.slice(_.orderBy(response, "value", "desc"), 0, 5);
}

function getPeriode(tabIndex) {
  let periode = "0-7";
  switch (tabIndex) {
    case 1:
      periode = "7-30";
      break;
    case 2:
      periode = "30-60";
      break;
    case 3:
      periode = "60";
      break;
    default:
      periode = "0-7";
      break;
  }

  return periode;
}

function getCategories(data = {}) {
  const categories = new Set();

  for (const categoriesName in data) {
    categories.add(categoriesName);
  }

  return [...categories];
}

function getCategoriesData(data = {}, keyData = "") {
  const result = [];

  for (const categories in data) {
    const tmp = data[categories];
    result.push(tmp[keyData]);
  }

  return result;
}

function GET_OVERALL_COLLECTION_DATA(data, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  let categories = [];
  const series = [];
  const tmpData = {};

  if (_isEmpty(data) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return { series, categories };
  }

  const periode = getPeriode(tabIndex);

  series[0] = { name: "Captured", data: [] };
  series[1] = { name: "Missing", data: [] };

  for (const countryName in data) {
    if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
      for (const siteName in data[countryName][periode]) {
        if (chosenSites[0] === "all") {
          const collection = data[countryName][periode];

          for (let i = 0; i < collection[siteName].length; i++) {
            const item = collection[siteName][i];
            const categoriesname = item[0];
            const captured = item[1];
            const missing = item[2];

            if (categoriesname in tmpData) {
              tmpData[categoriesname] = {
                captured: tmpData[categoriesname].captured + captured,
                missing: tmpData[categoriesname].captured + missing
              };
            } else {
              tmpData[categoriesname] = { captured: 0, missing: 0 };
              tmpData[categoriesname] = {
                captured: tmpData[categoriesname].captured + captured,
                missing: tmpData[categoriesname].captured + missing
              };
            }
          }
        } else {
          if (chosenSites.includes(siteName)) {
            const collection = data[countryName][periode];

            for (let i = 0; i < collection[siteName].length; i++) {
              const item = collection[siteName][i];
              const categoriesname = item[0];
              const captured = item[1];
              const missing = item[2];

              if (categoriesname in tmpData) {
                tmpData[categoriesname] = {
                  captured: tmpData[categoriesname].captured + captured,
                  missing: tmpData[categoriesname].captured + missing
                };
              } else {
                tmpData[categoriesname] = { captured: 0, missing: 0 };
                tmpData[categoriesname] = {
                  captured: tmpData[categoriesname].captured + captured,
                  missing: tmpData[categoriesname].captured + missing
                };
              }
            }
          }
        }
      }
    } else {
      if (Array.isArray(chosenCountries) && chosenCountries.includes(countryName)) {
        for (const siteName in data[countryName][periode]) {
          if (chosenSites[0] === "all") {
            const collection = data[countryName][periode];

            for (let i = 0; i < collection[siteName].length; i++) {
              const item = collection[siteName][i];
              const categoriesname = item[0];
              const captured = item[1];
              const missing = item[2];

              if (categoriesname in tmpData) {
                tmpData[categoriesname] = {
                  captured: tmpData[categoriesname].captured + captured,
                  missing: tmpData[categoriesname].captured + missing
                };
              } else {
                tmpData[categoriesname] = { captured: 0, missing: 0 };
                tmpData[categoriesname] = {
                  captured: tmpData[categoriesname].captured + captured,
                  missing: tmpData[categoriesname].captured + missing
                };
              }
            }
          } else {
            if (chosenSites.includes(siteName)) {
              const collection = data[countryName][periode];

              for (let i = 0; i < collection[siteName].length; i++) {
                const item = collection[siteName][i];
                const categoriesname = item[0];
                const captured = item[1];
                const missing = item[2];

                if (categoriesname in tmpData) {
                  tmpData[categoriesname] = {
                    captured: tmpData[categoriesname].captured + captured,
                    missing: tmpData[categoriesname].captured + missing
                  };
                } else {
                  tmpData[categoriesname] = { captured: 0, missing: 0 };
                  tmpData[categoriesname] = {
                    captured: tmpData[categoriesname].captured + captured,
                    missing: tmpData[categoriesname].captured + missing
                  };
                }
              }
            }
          }
        }
      }
    }
  }

  categories = _isEmpty(tmpData) ? [] : getCategories(tmpData);

  series[0].data = _isEmpty(tmpData) ? [] : getCategoriesData(tmpData, "captured");
  series[1].data = _isEmpty(tmpData) ? [] : getCategoriesData(tmpData, "missing");

  return { series, categories };
}

function getSiteID(searchKeyword, filterKey = "id", responseKey = "name") {
  const siteData = _.find(siteDetails, allSitesWithDetails => {
    return allSitesWithDetails[filterKey] === searchKeyword;
  });
  return _.get(siteData, responseKey, "");
}

const downloadCSV = (titleChart, header, data, specificSiteId = [], overrideTitle = null) => {
  const today = moment()
    .format("DD MMM YYYY hh:mm:ss")
    .toUpperCase();
  const title = titleChart || "";
  let fileName = title + "_" + today + ".csv";
  if (specificSiteId.length > 0) {
    fileName = title + "_" + today + "_" + getSiteID(specificSiteId[0]) + ".csv";
  }
  data.splice(0, 0, header);

  const fields = [];
  header.map((row, i) => {
    if (i === 0) {
      if (overrideTitle) {
        fields.push(overrideTitle);
      } else {
        fields.push(title);
      }
    } else if (i === header.length - 1) {
      fields.push(today);
    } else {
      fields.push("");
    }
  });

  const csv = papaparse.unparse({
    fields: fields,
    data: data
  });

  const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  let csvURL = null;
  if (navigator.msSaveBlob) {
    csvURL = navigator.msSaveBlob(csvData, "download.csv");
  } else {
    csvURL = window.URL.createObjectURL(csvData);
  }
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", fileName);
  tempLink.click();
};

function setSiteDetails(siteDataDetails) {
  siteDetails = siteDataDetails;
}

function getCountriesByActivities(rawData) {
  const isEmptyRaw = _.isEmpty(rawData);

  if (!isEmptyRaw) {
    let countriesList = new Set();
    for (const activityName in rawData) {
      const activities = rawData[activityName];
      for (const countryName in activities) {
        countriesList.add(countryName);
      }
    }

    return (countriesList = [...countriesList].sort((a, b) => b - a));
  }

  return [];
}

function getSiteByActivities(rawData, chosenCountries = []) {
  const isEmptyRaw = _.isEmpty(rawData);

  if (!isEmptyRaw) {
    let siteList = new Set();
    for (const activityName in rawData) {
      const activities = rawData[activityName];
      chosenCountries.forEach(countryName => {
        if (countryName in activities) {
          const sites = activities[countryName];

          for (const sitename in sites) {
            siteList.add(sitename);
          }
        }
      });
    }

    return (siteList = [...siteList].sort((a, b) => b - a));
  }

  return [];
}

function getSitesByGeneralAndActivities(rawData, chosenCountries = []) {
  const activity = _.get(rawData, "activities", null);
  const general = _.get(rawData, "general", null);

  const isEmptyData = (_.isEmpty(activity) && _.isEmpty(general)) || chosenCountries.length < 1;

  if (!isEmptyData) {
    let tmpSites = [];

    chosenCountries.forEach(countryName => {
      // Iterate from activity
      for (const activityName in activity) {
        const activities = activity[activityName];
        const countriesData = activities[countryName];
        const countriesKey = Object.keys(activities);

        if (countriesKey.indexOf(countryName) > -1) {
          tmpSites = tmpSites.concat(...Object.keys(countriesData));
        }
      }
      if (general !== null) {
        const countriesKeyFromGeneral = Object.keys(general);
        if (countriesKeyFromGeneral.indexOf(countryName) > -1) {
          const sites = Object.keys(general[countryName]);
          tmpSites = tmpSites.concat(sites);
        }
      }
    });
    tmpSites = _.uniq(tmpSites);
    tmpSites = _.orderBy(Array.from(tmpSites), [site => site.toLowerCase()]);
    return tmpSites;
  }

  return [];
}

export { getCountries, getContrast, primaryColorFnc, getSites, GET_OVERALL_COLLECTION_DATA, getDataOverallMissingData, getQueriesData, getQueriesStatusData, getQueriesTop5, downloadCSV, setSiteDetails, getSiteID, getCountriesByActivities, getSiteByActivities, getSitesByGeneralAndActivities };
